import {Color} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/color.types';
import {AddItemResponseStatus_Success_Section_BasketUrgency_InfoBox} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {useTranslation} from '@aboutyou/i18n';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {
  Alert,
  GenericIconName,
  Icon,
  UnstyledButton,
  tabFocusedStyles,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {PropsWithChildren} from 'react';
import {BASKET_URGENCY_INFO_KEY, BasketUrgencyInfo} from './BasketUrgencyInfo';

interface BasketUrgencyHintWrapperProps {
  className?: string;
  backgroundColor?: Color;
  foregroundColor?: Color;
  infoBox?: AddItemResponseStatus_Success_Section_BasketUrgency_InfoBox;
}

export const BasketUrgencyHintWrapper = ({
  children,
  backgroundColor,
  foregroundColor,
  infoBox,
  ref,
  ...rest
}: PropsWithChildren<BasketUrgencyHintWrapperProps> & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  const {open} = useOpenedStateManager(BASKET_URGENCY_INFO_KEY);
  const {t} = useTranslation();

  if (!children) {
    return null;
  }

  return (
    <Wrapper {...rest}>
      <Alert
        data-testid="basketUrgencyHintWrapper"
        type="CUSTOM"
        ref={ref}
        content={
          <>
            {children}
            {infoBox && (
              <>
                <Button
                  data-testid="basketUrgencyHintInfoIcon"
                  aria-label={t('Open basket hint info window')}
                  onClick={() => open()}
                >
                  <Icon asset={GenericIconName.Info} size="XSS" />
                </Button>
                <BasketUrgencyInfo infoBox={infoBox} />
              </>
            )}
          </>
        }
        customConfig={{
          backgroundColor: backgroundColor?.hex || '',
          borderColor: foregroundColor?.hex || '',
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-inline: 20px;
`;

const Button = styled(UnstyledButton)`
  position: absolute;
  top: 4px;
  right: 4px;

  &:focus-visible {
    ${tabFocusedStyles()}
  }
`;
